import { Discount } from 'shared-types/Common';
import React, { forwardRef, RefObject } from 'react';
import idGenerator from 'react-id-generator';
import { FormattedDate } from 'react-intl';
import moment from 'moment-timezone';
import { LightSpinner } from '../../LightSpinner';
import {
  DayOfMonth,
  DayPrice,
  Label,
  RadioInput,
  SpinnerWrapper,
  WeekdayName,
} from './SliderDateField.styles';
import { Price } from '../../Price';

interface SliderDateFieldProps {
  value: { price: {}; date: string; discount?: Discount };
  onChange: (_: any) => void;
  isChecked: boolean;
  isDataMissing?: boolean;
  isDisabled?: boolean;
  isPriceVisible: boolean;
  isLoading: boolean;
  radioRef: RefObject<HTMLInputElement>;
  id?: string;
}

export const SliderDateField = forwardRef<HTMLInputElement, SliderDateFieldProps>(
  (props, radioRef) => <SliderDateFieldBody {...props} radioRef={radioRef} />
);

const SliderDateFieldBody = (props) => {
  const {
    isChecked,
    value: { price, date, discount },
    isDataMissing,
    isDisabled,
    isPriceVisible,
    isLoading,
    radioRef,
    id,
  } = props;

  const radioId = id || idGenerator();

  const handleCheck = () => {
    const { onChange, value } = props;
    onChange(moment(value.date));
  };
  const hasDiscount = !!discount;
  return (
    <>
      <RadioInput
        id={radioId}
        type="radio"
        value={date}
        ref={radioRef}
        onChange={handleCheck}
        checked={isChecked}
        isDataMissing={isDataMissing}
        disabled={isDisabled}
        isPriceVisible={isPriceVisible}
        hasDiscount={hasDiscount}
        data-testid={'dates-slider-field-input'}
      />
      <Label htmlFor={radioId} isPriceVisible={isPriceVisible} isLoading={isLoading}>
        <WeekdayName>
          <FormattedDate value={date} weekday="short" />
        </WeekdayName>
        <DayOfMonth>
          <FormattedDate value={date} day="2-digit" />
        </DayOfMonth>
        {isPriceVisible && (
          <DayPrice hasDiscount={hasDiscount}>
            {price ? <Price price={discount?.discountedPrice || price} /> : <>&nbsp;</>}
          </DayPrice>
        )}
      </Label>
      <SpinnerWrapper $display={isLoading}>
        <LightSpinner />
      </SpinnerWrapper>
    </>
  );
};
